import { TCH_GET_CATEGORIES, TCH_LOADING_CATEGORIES, TCH_LOADING_CATEGORY, TCH_UPDATE_CATEGORY, TCH_GET_CATEGORY, TCH_UPDATE_MARKING } from "../../Actions/types";

const initialState = {
  categories: [],
  totals: 0,
  loading_categories: false,
  loading_category: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TCH_LOADING_CATEGORIES:
      return {
        ...state,
        loading_categories: true,
      };
    case TCH_LOADING_CATEGORY:
      return {
        ...state,
        loading_category: true,
      };
    case TCH_GET_CATEGORIES:
      return {
        ...state,
        categories: action.payload.data,
        totals: action.payload.totals,
        loading_categories: false,
      };
    case TCH_GET_CATEGORY:
        return {
          ...state,
          category: action.payload.data,
          loading_category: false,
        };
    case TCH_UPDATE_CATEGORY:
      let getData = [...state.categories];
      const updateElementId = element => element.id === action.payload_id;
      const findIndex = getData.findIndex(updateElementId);
      getData[findIndex].synonim = action.payload.data.synonim;
      getData[findIndex].marked = action.payload.data.marked;
      getData[findIndex].printed = action.payload.data.printed;
      return {
        ...state,
        category: action.payload.data,
        categories: getData,
        loading_category: false,
      };
    case TCH_UPDATE_MARKING:
        return {
          ...state
        };
    default:
      return state;
  }
}
